import {
	BuildingOfficeIcon,
	EnvelopeIcon,
	PencilIcon,
	PhoneIcon,
	TrashIcon,
	UserIcon,
} from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'

const truncate = value => {
	const text = value || '-'
	return text.length > 50 ? `${text.slice(0, 47)}...` : text
}

const getPlacowkaId = value => {
	if (!value) return null
	if (typeof value === 'object') return value?._id || value?.id || null
	return value
}

export default function OsobaTableRow({ osoba, onEdit, onDelete }) {
	const placowkaId = getPlacowkaId(osoba?.id_placowka)
	const placowkaNazwa = osoba?.id_placowka?.nazwa || '-'

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300">
				<div className="flex flex-col gap-1">
					<div className="flex items-center gap-2 whitespace-nowrap">
						<UserIcon className="h-4 w-4 shrink-0 text-gray-400" />
						<Link
							to={`/klienci/osoba/details/${osoba?._id || osoba?.id}`}
							className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
							{osoba?.imie_i_nazwisko || '-'}
						</Link>
						{osoba?.funkcja ? (
							<span className="text-sm text-gray-600">({osoba.funkcja})</span>
						) : null}
					</div>
					<div className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-600">
						<PhoneIcon className="h-4 w-4 shrink-0 text-gray-400" />
						{osoba?.telefon ? (
							<a
								href={`tel:${osoba.telefon}`}
								className="hover:text-blue-600 hover:underline">
								{osoba.telefon}
							</a>
						) : (
							<span>-</span>
						)}
					</div>
					<div className="flex items-center gap-2 whitespace-nowrap text-sm text-gray-600">
						<EnvelopeIcon className="h-4 w-4 shrink-0 text-gray-400" />
						{osoba?.email ? (
							<a
								href={`mailto:${osoba.email}`}
								className="hover:text-blue-600 hover:underline">
								{osoba.email}
							</a>
						) : (
							<span>-</span>
						)}
					</div>
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<div
					className="flex items-center gap-2"
					title={placowkaNazwa === '-' ? undefined : placowkaNazwa}>
					<BuildingOfficeIcon className="h-4 w-4 shrink-0 text-gray-400" />
					{placowkaId ? (
						<Link
							to={`/klienci/placowki/details/${placowkaId}`}
							className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
							{truncate(placowkaNazwa)}
						</Link>
					) : (
						truncate(placowkaNazwa)
					)}
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
				<div className="inline-flex items-center gap-2">
					<button
						type="button"
						onClick={() => onEdit(osoba)}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100">
						<PencilIcon className="h-4 w-4" />
						<span>Edytuj</span>
					</button>
					<button
						type="button"
						onClick={() => onDelete(osoba)}
						className="inline-flex items-center gap-1 rounded-md border border-red-100 bg-red-50 px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100">
						<TrashIcon className="h-4 w-4" />
						<span>Usuń</span>
					</button>
				</div>
			</td>
		</tr>
	)
}
